/**
 * Seconds before expiry at which callers should start proactively requesting a
 * refreshed access token.
 */
export const AUTH_TOKEN_REFRESH_BUFFER_SECONDS = 60 * 5;
